import React from 'react';
import { reduxForm } from 'redux-form';
import { pick } from 'underscore';

// containers
import CommercialSearch from './Search/CommercialSearch';
import LandSearch from './Search/LandSearch';
import RentalSearch from './Search/RentalSearch';
import ResidentialSearch from './Search/ResidentialSearch';
import ResidentialIncomeSearch from './Search/ResidentialIncomeSearch';

// components
import { PROPERTY_TYPE_MAP } from '../../ducks/PropertySearch';

// partials
import PropertyClassDropdown from '../../partials/property/property-class-dropdown';

// modules
import BS from '../../theme/Bootstrap';

let SearchForm = props => {
  const {
    initialValues: { propertyClass = 'residential' }
  } = props;

  return renderPropertyClassForm({
    propertyClass,
    ...props
  });
};

const renderPropertyClassForm = props => {
  const { propertyClass, initialValues } = props;
  const query = pick(initialValues, val => val !== undefined && val !== '');

  switch (propertyClass) {
    case 'rental':
      return (
        <RentalSearch {...props}>
          <PropertyClassDropdown
            {...props}
            query={query}
            propertyTypeMap={PROPERTY_TYPE_MAP}
            BS={BS}
          />
        </RentalSearch>
      );
    case 'commercial':
      return (
        <CommercialSearch {...props}>
          <PropertyClassDropdown
            {...props}
            query={query}
            propertyTypeMap={PROPERTY_TYPE_MAP}
            BS={BS}
          />
        </CommercialSearch>
      );
    case 'land':
      return (
        <LandSearch {...props}>
          <PropertyClassDropdown
            {...props}
            query={query}
            propertyTypeMap={PROPERTY_TYPE_MAP}
            BS={BS}
          />
        </LandSearch>
      );
    case 'residential_income':
      return (
        <ResidentialIncomeSearch {...props}>
          <PropertyClassDropdown
            {...props}
            query={query}
            propertyTypeMap={PROPERTY_TYPE_MAP}
            BS={BS}
          />
        </ResidentialIncomeSearch>
      );
    case 'residential':
    default:
      return (
        <ResidentialSearch {...props}>
          <PropertyClassDropdown
            {...props}
            query={query}
            propertyTypeMap={PROPERTY_TYPE_MAP}
            BS={BS}
          />
        </ResidentialSearch>
      );
  }
};

const PropertySearchForm = reduxForm({
  form: 'property-search-form'
})(SearchForm);

export default PropertySearchForm;



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertySearchForm.js